import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getSubscribePortPushTenantList() {
  return request({
    url: URL.sys.getSubscribePortPushTenantList,
    method: 'get'
  })
}

export function getSubscribePortPush(params) {
  return request({
    url: URL.sys.getSubscribePortPush,
    method: 'get',
    params
  })
}

export function addPushRule(data) {
  return request({
    url: URL.sys.addPushRule,
    method: 'post',
    data
  })
}

export function remove(params) {
  return request({
    url: URL.sys.removeSubscribePortPushRule,
    method: 'post',
    params
  })
}

// 查询推送服务商配置
export function queryPortConfig(data) {
  return request({
    url: URL.sys.queryPortConfig,
    method: 'post',
    data
  })
}

// 批量保存/新增推送服务商配置
export function saveBatch(data) {
  return request({
    url: URL.sys.saveBatch,
    method: 'post',
    data
  })
}
// 批量保存/新增空运推送服务商配置
export function saveAirConfig(data) {
  return request({
    url: URL.sys.saveAirConfig,
    method: 'post',
    data
  })
}

// 查询港区数据推送配置订阅
export function querySubscribeConfig(data) {
  return request({
    url: URL.sys.querySubscribeConfig,
    method: 'post',
    data
  })
}

// 新增港区数据推送配置订阅
export function addSubscribeConfig(data) {
  return request({
    url: URL.sys.addSubscribeConfig,
    method: 'post',
    data
  })
}

// 更新港区数据推送配置订阅
export function updateSubscribeConfig(data) {
  return request({
    url: URL.sys.updateSubscribeConfig,
    method: 'post',
    data
  })
}

// 删除港区数据推送配置订阅
export function delSubscribeConfig(data) {
  return request({
    url: URL.sys.delSubscribeConfig,
    method: 'post',
    data
  })
}

// 查询用户是否开启港区数据推送
export function getOpenPortDataService(params) {
  return request({
    url: URL.sys.getOpenPortDataService,
    method: 'get',
    params
  })
}

// 查询空运数据推送配置订阅
export function queryAirSubscribeConfig(data) {
  return request({
    url: URL.sys.queryAirSubscribeConfig,
    method: 'post',
    data
  })
}

// 查询空运数据推送配置订阅
export function getAirPortDataConfig(data) {
  return request({
    url: URL.sys.getAirPortDataConfig,
    method: 'post',
    data
  })
}
// 查询空运数据推送配置订阅
export function getAirPortDataConfigAll() {
  return request({
    url: URL.sys.getAirPortDataConfigAll,
    method: 'get'
  })
}
// 新增空运数据推送配置订阅
export function addAirSubscribeConfig(data) {
  return request({
    url: URL.sys.addAirSubscribeConfig,
    method: 'post',
    data
  })
}

// 更新空运数据推送配置订阅
export function updateAirSubscribeConfig(data) {
  return request({
    url: URL.sys.updateAirSubscribeConfig,
    method: 'post',
    data
  })
}

// 删除空运数据推送配置订阅
export function delAirSubscribeConfig(data) {
  return request({
    url: URL.sys.delAirSubscribeConfig,
    method: 'post',
    data
  })
}

// 获取数据服务账号配置
export function getPortDataServiceAccount(data) {
  return request({
    url: URL.sys.getPortDataServiceAccount,
    method: 'post',
    data
  })
}

// 新增数据服务账号配置
export function addPortDataServiceAccount(data) {
  return request({
    url: URL.sys.addPortDataServiceAccount,
    method: 'post',
    data
  })
}

// 更新数据服务账号配置
export function updatePortDataServiceAccount(data) {
  return request({
    url: URL.sys.updatePortDataServiceAccount,
    method: 'post',
    data
  })
}

// 删除数据服务账号配置
export function delPortDataServiceAccount(data) {
  return request({
    url: URL.sys.deletePortDataServiceAccount,
    method: 'post',
    data
  })
}

// 是否维护过数据服务账号配置
export function isMaintainedPortDataServiceAccount(data) {
  return request({
    url: URL.sys.isMaintainedPortDataServiceAccount,
    method: 'post',
    data
  })
}
